import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../css/styles.css";

// Import images so webpack processes them
import img1 from "../assets/1.jpeg";
import img2 from "../assets/2.jpeg";
import img3 from "../assets/3.jpeg";
import img4 from "../assets/4.jpeg";
import img5 from "../assets/5.jpeg";
import img6 from "../assets/6.jpeg";

gsap.registerPlugin(ScrollTrigger);

// Set image sources dynamically after DOM loads
window.addEventListener('DOMContentLoaded', () => {
  const images = [img1, img2, img3, img4, img5, img6];
  document.querySelectorAll('.dest-card img').forEach((img, index) => {
    if (images[index]) {
      img.src = images[index];
    }
  });
});

// ── Custom Cursor + Splash Light ──
const cursor = document.getElementById("cursor");
const splash = document.getElementById("cursorSplash");
const ripple = document.getElementById("cursorRipple");
let mouseX = 0,
  mouseY = 0,
  curX = 0,
  curY = 0;
let splashX = 0,
  splashY = 0,
  rippleX = 0,
  rippleY = 0;
let isMoving = false,
  moveTimeout;

document.addEventListener("mousemove", (e) => {
  mouseX = e.clientX;
  mouseY = e.clientY;
  isMoving = true;
  splash.style.opacity = "1";
  ripple.style.opacity = "1";
  clearTimeout(moveTimeout);
  moveTimeout = setTimeout(() => {
    isMoving = false;
  }, 150);
});

document.addEventListener("mouseleave", () => {
  splash.style.opacity = "0";
  ripple.style.opacity = "0";
});

// Organic distortion: slight wobble in splash size
let wobblePhase = 0;

gsap.ticker.add(() => {
  curX += (mouseX - curX) * 0.15;
  curY += (mouseY - curY) * 0.15;
  cursor.style.left = curX + "px";
  cursor.style.top = curY + "px";

  // Splash follows with slower, fluid lag
  splashX += (mouseX - splashX) * 0.08;
  splashY += (mouseY - splashY) * 0.08;
  splash.style.left = splashX + "px";
  splash.style.top = splashY + "px";

  // Ripple follows even slower for layered depth
  rippleX += (mouseX - rippleX) * 0.12;
  rippleY += (mouseY - rippleY) * 0.12;
  ripple.style.left = rippleX + "px";
  ripple.style.top = rippleY + "px";

  // Organic wobble
  wobblePhase += 0.03;
  const wobbleScale = 1 + Math.sin(wobblePhase) * 0.08;
  const wobbleScaleY = 1 + Math.cos(wobblePhase * 0.7) * 0.06;
  splash.style.transform = `translate(-50%, -50%) scale(${wobbleScale}, ${wobbleScaleY})`;
});

document.querySelectorAll("a, button, .dest-card").forEach((el) => {
  el.addEventListener("mouseenter", () => cursor.classList.add("hover"));
  el.addEventListener("mouseleave", () =>
    cursor.classList.remove("hover"),
  );
});

// ── Hero Animations ──
const heroTl = gsap.timeline({ defaults: { ease: "power4.out" } });

heroTl
  .from("#heroBg", { scale: 1.3, duration: 2.5, ease: "power2.out" })
  .from("#brand", { y: -30, opacity: 0, duration: 1 }, 0.3)
  .from("#brandTag", { y: -30, opacity: 0, duration: 1 }, 0.4)
  .from("#line1", { y: 120, opacity: 0, duration: 1.2 }, 0.5)
  .from("#line2", { y: 120, opacity: 0, duration: 1.2 }, 0.7)
  .from("#line3", { y: 120, opacity: 0, duration: 1.2 }, 0.9)
  .from("#heroSub", { y: 40, opacity: 0, duration: 1 }, 1.3)
  .from("#scrollHint", { opacity: 0, y: 20, duration: 0.8 }, 1.6);

// ── Hero Parallax ──
gsap.to("#heroBg", {
  y: "30%",
  ease: "none",
  scrollTrigger: {
    trigger: ".hero",
    start: "top top",
    end: "bottom top",
    scrub: true,
  },
});

// ── Philosophy Section ──
const philTl = gsap.timeline({
  scrollTrigger: {
    trigger: ".philosophy",
    start: "top 80%",
    end: "center center",
    scrub: 1,
  },
});

philTl
  .from("#philLabel", { y: 40, opacity: 0 })
  .from("#philText", { y: 60, opacity: 0 }, 0.1)
  .from(
    "#philLine",
    { scaleX: 0, transformOrigin: "center", opacity: 0 },
    0.3,
  );

// ── Bhutan Quote ──
gsap.from("#bhutanQuote blockquote", {
  scrollTrigger: {
    trigger: "#bhutanQuote",
    start: "top 75%",
    toggleActions: "play none none reverse",
  },
  y: 50,
  opacity: 0,
  duration: 1.4,
  ease: "power3.out",
});

gsap.from("#bhutanQuote cite", {
  scrollTrigger: {
    trigger: "#bhutanQuote",
    start: "top 70%",
    toggleActions: "play none none reverse",
  },
  opacity: 0,
  duration: 1,
  delay: 0.5,
  ease: "power2.out",
});

// ── Destination Cards ──
gsap.from("#destTitle", {
  scrollTrigger: {
    trigger: ".destinations",
    start: "top 75%",
    toggleActions: "play none none reverse",
  },
  y: 80,
  opacity: 0,
  duration: 1.2,
  ease: "power3.out",
});

gsap.from("#destSub", {
  scrollTrigger: {
    trigger: ".destinations",
    start: "top 70%",
    toggleActions: "play none none reverse",
  },
  y: 40,
  opacity: 0,
  duration: 1,
  delay: 0.3,
  ease: "power3.out",
});

document.querySelectorAll(".dest-card").forEach((card, i) => {
  gsap.from(card, {
    scrollTrigger: {
      trigger: card,
      start: "top 85%",
      toggleActions: "play none none reverse",
    },
    y: 100,
    opacity: 0,
    duration: 1.2,
    delay: (i % 3) * 0.15,
    ease: "power3.out",
  });

  card.addEventListener("mousemove", (e) => {
    const rect = card.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;
    gsap.to(card, {
      rotateY: x * 8,
      rotateX: -y * 5,
      transformPerspective: 800,
      duration: 0.4,
      ease: "power2.out",
    });
  });

  card.addEventListener("mouseleave", () => {
    gsap.to(card, {
      rotateY: 0,
      rotateX: 0,
      duration: 0.6,
      ease: "power2.out",
    });
  });
});

// ── Altitude Stats ──
document.querySelectorAll(".alt-stat").forEach((stat, i) => {
  gsap.from(stat, {
    scrollTrigger: {
      trigger: "#altBar",
      start: "top 80%",
      toggleActions: "play none none reverse",
    },
    y: 50,
    opacity: 0,
    duration: 1,
    delay: i * 0.2,
    ease: "power3.out",
  });
});

// ── CTA Section ──
const ctaTl = gsap.timeline({
  scrollTrigger: {
    trigger: ".cta",
    start: "top 65%",
    toggleActions: "play none none reverse",
  },
});

ctaTl
  .from("#ctaQ", { y: 80, opacity: 0, duration: 1.2, ease: "power3.out" })
  .from(
    "#ctaInput",
    { y: 40, opacity: 0, duration: 0.8, ease: "power3.out" },
    0.4,
  )
  .from("#ctaFine", { opacity: 0, duration: 0.6 }, 0.8);

// ── Footer ──
gsap.from("#footer", {
  scrollTrigger: {
    trigger: "#footer",
    start: "top 95%",
    toggleActions: "play none none reverse",
  },
  opacity: 0,
  y: 20,
  duration: 0.8,
});

// ── CTA Button hover ──
const ctaBtn = document.querySelector(".cta-input-wrap button");
ctaBtn.addEventListener("mouseenter", () => {
  gsap.to(ctaBtn, { scale: 1.05, duration: 0.3 });
});
ctaBtn.addEventListener("mouseleave", () => {
  gsap.to(ctaBtn, { scale: 1, duration: 0.3 });
});

// ── Web3Forms Submission ──
const ctaForm = document.getElementById("ctaForm");
const ctaMessage = document.getElementById("ctaMessage");

if (ctaForm) {
  ctaForm.addEventListener("submit", async (e) => {
    e.preventDefault();

    const formData = new FormData(ctaForm);
    const submitButton = ctaForm.querySelector('button[type="submit"]');
    const originalText = submitButton.textContent;

    // Show loading state
    submitButton.textContent = "Sending...";
    submitButton.disabled = true;

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData
      });

      const data = await response.json();

      if (data.success) {
        ctaMessage.textContent = "Welcome to the journey. Check your email.";
        ctaMessage.className = "cta-message success";
        ctaForm.reset();
      } else {
        throw new Error(data.message || "Something went wrong");
      }
    } catch (error) {
      ctaMessage.textContent = "Something went wrong. Please try again.";
      ctaMessage.className = "cta-message error";
    } finally {
      submitButton.textContent = originalText;
      submitButton.disabled = false;
    }
  });
}
